import React, { Component } from 'react'
import { RouteComponentProps } from 'react-router-dom'

import PageLayout from 'components/layout/pageLayout'
import SubNavigation from 'components/layout/subNavigation'
import Head from 'components/layout/head'

interface LinksAbkProps extends RouteComponentProps<any> {
  authenticated: boolean
  dispatch: any
}

interface ILink {
  href: string
  label: string
}

type LinksAbkState = {
  links: ILink[]
}

class LinksAbk extends Component<LinksAbkProps, LinksAbkState> {
  renderLinksAbk = (links: ILink[]) =>
    links.map((link: ILink, index: number) => (
      <a
        key={index}
        className="link text-15 leading-22 tracking-0.1"
        target="_blank"
        rel="noopener noreferrer"
        href={link.href}
      >
        {link.label}
      </a>
    ))

  render() {
    return (
      <PageLayout pageTitle="FAQ">
        <Head
          headline="FAQ"
          subheadline="ABK calcKit – der Baukasten für die schnelle Kalkulation"
        />
        <SubNavigation
          items={[
            {
              label: 'Nutzungsbedingungen',
              link: '/faq/terms-of-use',
            },
            {
              label: 'Tutorial',
              link: '/faq/tutorial',
            },
            {
              label: 'Links',
              link: '/faq/links',
            },
          ]}
        />
        <div className="flex flex-row px-48 mb-65">
          <div className="w-5/12 flex flex-col">
            {this.renderLinksAbk([
              {
                label: 'www.abk.at',
                href: 'https://www.abk.at',
              },
              {
                label: 'www.baudaten.info',
                href: 'https://www.baudaten.info',
              },
            ])}
          </div>
        </div>
      </PageLayout>
    )
  }
}

export default LinksAbk
